import { render } from "./SelectFilter.vue?vue&type=template&id=3f39765a"
import script from "./SelectFilter.vue?vue&type=script&lang=js"
export * from "./SelectFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectFilter.vue"]])

export default __exports__